import { render, staticRenderFns } from "./AddPayoutMethod.vue?vue&type=template&id=7b47f263&"
import script from "./AddPayoutMethod.vue?vue&type=script&lang=js&"
export * from "./AddPayoutMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports